import type { ChartDisplayMode } from './elecNonresidentialChartSegments';
import { ELEC_EMISSION_FACTOR_MT_PER_KWH } from './bhSourceControls';
import type { CanonicalEnergyActivityYear } from './types';

export interface BurbankElecComIndStackSegments {
  commercial: number | null;
  industrial: number | null;
}

function roundDisplay(n: number, mode: ChartDisplayMode): number {
  if (mode === 'emissions') return Math.round(n * 10) / 10;
  return Math.round(n);
}

function comIndStackYearEligible(row: CanonicalEnergyActivityYear): boolean {
  if (row.fuel !== 'electricity') return false;
  const comKwh = row.nonresidential.commercialComponent ?? row.commercial.commercialComponent;
  if (comKwh == null || comKwh <= 0) return false;
  if (row.nonresidential.sourceClass === 'cap_published') return true;
  if (row.nonresidential.coverage === 'complete_observed') return true;
  if (row.industrial.sourceClass === 'utility_observed') return true;
  return false;
}

export function buildBurbankElecComIndStackSegments(
  row: CanonicalEnergyActivityYear,
  mode: ChartDisplayMode
): BurbankElecComIndStackSegments {
  if (!comIndStackYearEligible(row)) {
    return { commercial: null, industrial: null };
  }
  const comKwh = row.nonresidential.commercialComponent ?? row.commercial.commercialComponent ?? 0;
  const indKwh = row.nonresidential.industrialComponent ?? row.industrial.value;
  const hasInd = indKwh != null && indKwh > 0;
  const factor = ELEC_EMISSION_FACTOR_MT_PER_KWH;
  if (mode === 'emissions') {
    return {
      commercial: roundDisplay(comKwh * factor, mode),
      industrial: hasInd ? roundDisplay(indKwh! * factor, mode) : null,
    };
  }
  return {
    commercial: roundDisplay(comKwh, mode),
    industrial: hasInd ? roundDisplay(indKwh!, mode) : null,
  };
}
